export const briefLiveHeaderText = 'Brief Live';

export const briefLiveFilterText = {
  giveawaySearchPlaceholder: 'Cari...',
  brandPlaceholder: 'Pilih Brand',
  draftStatusPlaceholder: 'Pilih Status Draft',
  statusPlaceholder: 'Pilih Status',
  createBriefText: 'Buat Brief',
  createGiveawayText: 'Buat Giveaway',
  tooltipGiveawayText: 'Informasi Giveaway dikelola secara terpisah dan tidak terhubung dengan Magpie',
};

export const briefLiveTabText = {
  talkingPointText: 'Talking Point',
  giveawayText: 'Giveaway',
};

export const talkingPointDeleteActionText = {
  titleText: 'Apakah kamu yakin ingin menghapus Talking Point ini?',
  descriptionText: 'Tindakan ini tidak bisa dibatalkan, dan semua detail terkait akan hilang',
  submitButtonText: 'Ya',
  cancelButtonText: 'Batal',
  successDescription: 'Talking Point berhasil dihapus',
  errorTitle: 'Gagal menghapus Talking Point',
  errorDescription: 'Terjadi kesalahan saat menghapus Talking Point',
};

export const giveawayItemDeleteActionText = {
  titleText: 'Apakah kamu yakin ingin menghapus Hadiah dan Syarat ini?',
  descriptionText: 'Tindakan ini tidak bisa dibatalkan, dan semua detail terkait akan hilang',
  submitButtonText: 'Ya',
  cancelButtonText: 'Batal',
};

export const giveawayDeleteActionText = {
  titleText: 'Apakah kamu yakin ingin menghapus Giveaway ini?',
  descriptionText: 'Tindakan ini tidak bisa dibatalkan, dan semua detail terkait, seperti daftar pemenang dan lainnya akan hilang',
  submitButtonText: 'Ya',
  cancelButtonText: 'Batal',
  successDescription: 'Giveaway berhasil dihapus',
  errorTitle: 'Gagal menghapus Giveaway',
  errorDescription: 'Terjadi kesalahan saat menghapus Giveaway',
};

export const modalDetailWinnerText = {
  title: 'Detail Pemenang Giveaway',
  brand: 'Brand',
  stock: 'Stok',
  columnPicture: 'Foto Bukti',
  columnUpdatedAt: 'Waktu Update',
  columnStockUsed: 'Stok Terpakai',
  columnWinnerInfo: 'Info Pemenang',
  columnHost: 'Host',
  columnGiveawayDuration: 'Durasi Giveaway',
  columnAccount: 'Account',
};

export const modalPrizeListText = {
  title: 'Daftar Giveaway',
  brand: 'Brand',
  createdAt: 'Waktu Terbuat',
  columnPrize: 'Hadiah',
  columnStock: 'Stok',
  columnUsedStock: 'Stok Terpakai',
};

export const attachmentImageText = {
  alt: 'Attachment Image',
};

export const giveawayFormInsertText = {
  createTitle: 'Buat Giveaway',
  editTitle: 'Edit Giveaway',
  cancelCreateButtonText: 'Batal',
  cancelEditButtonText: 'Kembali',
  saveButtonText: 'Simpan',
  brandLabelText: 'Brand',
  nameGiveawayText: 'Nama Giveaway',
  giftRequirementTitleText: 'Hadiah & Syarat',
  giftRequirementButtonText: 'Hadiah & Syarat Baru',
  giftTitle: 'Informasi Hadiah',
  giftProductLabel: 'Nama Produk',
  giftProductPlaceholder: 'Masukkan Nama',
  giftStockLabel: 'Total Stok',
  requirementTitle: 'Syarat',
  durationTitle: 'Durasi Giveaway',
  giveawayTypeLabel: 'Tipe Giveaway',
  notePlaceholder: 'Catatan (opsional)',
  addDurationButtonText: 'Tambah Durasi',
  minPurchaseLabelText: 'Minimal belanja',
  withProductLabelText: 'Dengan Pembelian Produk',
  addProductButtonText: 'Tambah Produk',
  purchaseProductText: 'Pembelian Produk',
  withProductPurchaseLabelText: 'Dengan Pembelian',
  inputProductPlaceholderText: 'Cari…',
  allocationStockLabelText: 'Alokasi Stok',
  accountLabel: 'Account ID',
  accountPlaceholderText: 'Pilih Account ID',
};

export const giveawayFormUpdateText = {
  brandLabelText: 'Brand',
  namaGiveawayLabelText: 'Nama Giveaway',
  cancelButtonText: 'Batal',
  saveButtonText: 'Simpan',
  giftRequirementTitleText: 'Hadiah & Syarat',
  giftRequirementButtonText: 'Hadiah & Syarat Baru',
  giftTitle: 'Informasi Hadiah',
  totalStockLabelText: 'Total Stok',
  requirementTitle: 'Syarat',
  durationTitle: 'Durasi Giveaway',
  minPurchaseLabelText: 'Minimal belanja',
  withProductPurchaseLabelText: 'Dengan Pembelian',
  purchaseProductText: 'Pembelian Produk',
  accountLabel: 'Account ID',
  allocationStockLabelText: 'Alokasi Stok',
  waktuTampilLabelText: 'Waktu Tampil',
};

export const tableListTalkingPointText = {
  columnCreatedAt: 'Waktu Terbuat',
  columnActiveTime: 'Waktu Aktif',
  columnTitle: 'Judul',
  columnDraftStatus: 'Status Draft',
  columnStatus: 'Status',
  columnAction: 'Action',
};

export const talkingPointUpsertText = {
  successSaveDraft: 'Talking Point berhasil tersimpan dalam Draft!',
  create: {
    successDescription: 'Talking Point berhasil tersimpan',
    errorDescription: 'Gagal menyimpan Talking Point',
  },
  edit: {
    successDescription: 'Talking Point berhasil diperbarui',
    errorDescription: 'Gagal memperbarui Talking Point',
  },
  saveDraftButtonText: 'Simpan Draft',
  saveButtonText: 'Simpan',
  cancelButtonText: 'Batal',
  createTitleText: 'Buat Talking Point',
  detailTitleText: 'Detail Talking Point',
  editTitleText: 'Edit Talking Point',
  titleBriefLabelText: 'Judul Talking Point',
  titleBriefPlaceholderText: 'Masukkan Judul Talking Point',
  productHighlightLabelText: 'Product Highlight',
  productHighlightDescText: 'Cari produk yang ingin kamu highlight atau tambah produk baru secara manual',
  productHighlightAddProductButtonText: 'Tambah Produk',
  productHighlightAddManualProductButtonText: 'Tambah Manual',
  productHighlightNotePlaceholderText: 'Catatan (opsional)',
  productHighlightNamePlaceholderText: 'Cari Nama Produk atau SKU ID',
  productHighlightSkuPlaceholderText: 'SKU ID (opsional)',
  brandLabelText: 'Brand',
  brandPlaceholderText: 'Pilih brand',
  displayDateLabelText: 'Waktu Tampil',
  displayDatePlaceholderText: 'Pilih Tanggal',
  displayDateInfoText: 'Waktu brief akan tampil di halaman host',
  sectionTitlePlaceholderText: 'Masukkan Judul Brief',
  sectionDescriptionPlaceholderText: 'Deskripsi',
  calendarStatusTooltip: {
    published: {
      title: 'Talking Point Aktif',
      description: 'sudah ada talking point aktif pada tanggal tersebut',
    },
    draft: {
      title: 'Talking Point Draft',
      description: 'sudah ada draft talking point yang akan aktif pada tanggal tersebut',
    },
  },
};
